import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";
import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import { mainLayoutStyles } from "../../../../../constants";
import { Toast } from "../../../../../common/alert";

import {
  getAllClassroomAudioReactions,
  classroomAudioReactionsSearch,
} from "../../hooks/GAClassroomAudioReactionsHooks";
import GAClassroomAudioReactionsTable from "../../components/GAClassroomAudioReactionsTable/GAClassroomAudioReactionsTable";
import SearchBar from "../../components/SearchBar/SearchBar";

const GAClassroomAudioReactionsContainer = () => {
  const [loading, setLoading] = useState(false);
  const [allRows, setAllRows] = useState([]);
  const [rows, setRows] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const data = await getAllClassroomAudioReactions();
      setAllRows(data);
      setRows(data);
    } catch (e) {
      console.error("Error loading classroomAudioReactions:", e);
      Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleSearch = (e) => {
    try {
      const value = e.target.value;
      if (value.length >= 1) {
        const filtered = classroomAudioReactionsSearch(allRows, value);
        setRows(filtered);
      } else {
        setRows(allRows);
      }
    } catch (error) {
      console.log("error searching classroom audio reactions:", error.message);
    }
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4, marginTop: '60px' }}>
      <CssBaseline />
      <Header mainTitle={"Classroom Audio Reactions"} bgColor="#fff" />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <SearchBar
            placeholder={"Search"}
            handleSearch={handleSearch}
          />
          <GAClassroomAudioReactionsTable rows={rows} />
        </Grid>
      </Grid>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default GAClassroomAudioReactionsContainer;
